import { Component, OnInit, SecurityContext } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/util/util.service';
import { HttpHeaders } from '@angular/common/http';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CROSS } from 'src/defaultImages.js';
import { DomSanitizer} from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { BillingCountersDataService } from '../../services/billing-counters-data.service';

@Component({
  selector: 'app-drawer-kick',
  templateUrl: './drawer-kick.component.html',
  styleUrls: ['../update-cash/update-cash.component.css'],
})
export class DrawerKickComponent implements OnInit {
  images = {
    CROSS: CROSS,
  };
  reasons = [
    { id: 'customer refund', name: 'Customer Refund' },
    { id: 'customer change request', name: 'Customer Change Request' },
    { id: 'cash float change', name: 'Cash Float Change' },
  ];
  cashCollectForm: FormGroup;
  now = new Date();
  selectedOption: string;
  reason_text: string;
  staff_name: string;
  btnDisabled: boolean = false;
  dkick_code: any = [];
  isLoading: boolean = false;
  modalTexts: any;
  translationText;
  billingCounterInfo: string = '';
  billingCounterName: string = '';
  subscription: Subscription = new Subscription();

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private apiService: ApiService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private util: UtilService,
    private _eventTracker: EventTrackerService,
    private _router: Router,
    public translateService: TranslateService,
    private _sanitizer: DomSanitizer,
    private _counterDataService: BillingCountersDataService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
  }

  ngOnInit() {
    this.translateService.get('OPEN_CASH_DRAWER').subscribe((data: any) => {
      this.modalTexts = { ...data };
      this.reasons = [
        { id: 'customer refund', name: this.modalTexts.CUSTOMER_REFUND },
        { id: 'customer change request', name: this.modalTexts.CUST_CHG_REQ },
        { id: 'cash float change', name: this.modalTexts.CASH_FLT_CHGE },
      ];
    });

    this.cashCollectForm = this.fb.group({
      staff_name: ['', Validators.required],
    });
    this.setRadio(this.reasons && this.reasons[0] ? this.reasons[0].id : null);
    this.getRestaurantDetails();
    this.getBillingCounterName();
  }
  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
          if (this.billingCounterName) {
            this.setSubHeading('BILLING_COUNTER_DRAWER');
          }
        })
    );
  }
  private setSubHeading(translationString: string): void {
    const counterSubHeading = this.modalTexts[translationString]?.replace(
      '{{billingCounterName}}',
      this.billingCounterName
    );
    this.sanitizeHtml(counterSubHeading);
  }
  private sanitizeHtml(html: string): void {
    this.billingCounterInfo = this._sanitizer.sanitize(
      SecurityContext.HTML,
      html
    );
  }
  getRestaurantDetails() {
    const formData = new FormData();
    formData.append('restaurant_id', localStorage.getItem('restaurant_id'));
    this.apiService.getRestaurantDetails(formData).subscribe((res: any) => {
      if (res.status == 1) this.dkick_code = res.data.dkick_code;
    });
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  radioChanged(e) {}
  setRadio(id) {
    this.selectedOption = id;
  }
  save_clicked() {
    this.cashCollectForm.markAllAsTouched();
    if (this.cashCollectForm.valid) {
      this.btnDisabled = true;
      this.isLoading = true;
      const form = this.cashCollectForm.value;
      const payload = {
        restaurant_id: localStorage.getItem('restaurant_id'),
        staff_name: form.staff_name,
      };
      if (this.selectedOption == 'custom') {
        if (
          !(
            this.reason_text == '' ||
            this.reason_text == null ||
            this.reason_text == undefined
          )
        )
          payload['reason'] = this.reason_text;
        else {
          this.messageService.info(`${this.modalTexts.ENTER_RSN_DK}`);
          this.btnDisabled = false;
          return;
        }
      } else payload['reason'] = this.selectedOption;

      payload['device_id'] = this.util.getDeviceUID();

      let httpOptions: { headers } = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${
            localStorage.getItem('temp_access_token')
              ? localStorage.getItem('temp_access_token')
              : localStorage.getItem('token')
          }`,
        }),
      };
      this.apiService.addDrawerKickDetails(payload).subscribe(
        (response) => {
          this.isLoading = false;
          if (response.statusCode == 201) {
            // Send data to React
            if (this.util.cashRegistryEnabled()) {
              const isMultiCashDrawerEnabled = this.util.isMultiCashDrawerEnabled();
              const deviceId = this.util.getDeviceUID();
              const data = {
                restaurant_id: localStorage.getItem('restaurant_id'),
                txn_id: response.data.txn_id,
                dkick_code: this.dkick_code,
                action: 'drawer-kick',
                ...(isMultiCashDrawerEnabled && { device_id: deviceId }),
              };
              this.util.send_data_to_react(data, 'drawer-kick');
              this.util.openCashDrawer();
              this.util.openCashDrawerPrintReceipt(
                {
                  restaurant_id: localStorage.getItem('restaurant_id'),
                  txn_id: response.data.txn_id,
                },
                'drawer-kick'
              );
            }
            this.messageService.showSuccess(`${this.modalTexts.ADD_SUCCESS}`);
            this.dialogRef.close({ data: 'success' });
            this.btnDisabled = false;
          }
          localStorage.setItem('temp_access_token', null);
        },
        (error) => {
          this.isLoading = false;
          this.messageService.showError(error.error.message);
          this.dialogRef.close({ data: 'closed' });
          this.btnDisabled = false;
          localStorage.setItem('temp_access_token', null);
        }
      );

      this._eventTracker.easyeat_track_event('DRAWER_KICK_DONE', {
        'SOURCE TAB': this._router.url.includes('orders')
          ? 'ORDER DASHBOARD'
          : 'CASH BALANCE',
        'STAFF NAME': form.staff_name,
        'CASH CHANGE': parseFloat(form.amount),
        REASON:
          this.selectedOption === 'custom'
            ? this.reason_text
            : this.selectedOption,
      });
    }
  }
}
